import { FC, PropsWithChildren, ReactElement } from 'react'

import './ModalContent.scss'

interface ModalContentProps {
    title: string
    className?: string
    contentWrapperClassName?: string
}

export const ModalContent: FC<PropsWithChildren<ModalContentProps>> = ({
    title,
    children,
    className = '',
    contentWrapperClassName = '',
}): ReactElement => (
    <div className={`modal-content ${className}`}>
        <header className="modal-content__header">
            <h2 className="modal-content__title">{title}</h2>
        </header>

        <div className={`modal-content__content-wrapper ${contentWrapperClassName}`}>
            {children}
        </div>
    </div>
)
